/** Paths from Onramper brand asset: onramper-logomark-light.svg (viewBox 0 0 465 250) */
const ONRAMPER_LOGOMARK_PATH =
  "M339.321 0C408.491 0 464.549 56.0582 464.549 125.229C464.549 194.4 408.491 250 339.321 250H125.023C55.8522 250 0.251953 194.4 0.251953 125.229C0.251953 56.0582 55.8522 0 125.023 0H339.321ZM250.252 125.229C250.252 174.96 289.59 213.84 339.307 213.84C389.024 213.84 428.361 174.96 428.361 125.229C428.361 75.4981 388.58 36.1742 339.307 36.1742C289.59 36.1742 250.252 75.956 250.252 125.229ZM214.536 125.229C214.536 90.4146 228.55 58.7778 251.154 36.1742H232.172C182.441 36.1742 143.117 75.956 143.117 125.229C143.117 174.502 180.637 212.036 228.564 213.84H251.168C228.55 191.236 214.536 160.043 214.536 125.229ZM35.9682 125.229C35.9682 174.502 75.3061 213.84 125.023 213.84H144.005C121.401 191.236 107.387 160.043 107.387 125.229C107.387 90.4146 121.401 58.7778 144.005 36.1742H125.023C75.2922 36.1742 35.9682 75.956 35.9682 125.229Z";

export default function OnramperLogo({ className }: { className?: string }) {
  const vbW = 465;
  const vbH = 250;
  const size = 32;
  const pad = 2;
  const inner = size - 2 * pad;
  const scale = inner / vbW;
  const tx = (size - vbW * scale) / 2;
  const ty = (size - vbH * scale) / 2;

  return (
    <svg
      className={className}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={size} height={size} rx="6" fill="#1F00FF" />
      <g transform={`translate(${tx} ${ty}) scale(${scale})`}>
        <path d={ONRAMPER_LOGOMARK_PATH} fill="white" />
      </g>
    </svg>
  );
}
